import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

const Platforms = () => {

    const swiperRef: any = useRef(null);
    const slides = [
	{ title: 'Mobile', text: 'On the go, always with you' },
	{ title: 'Desktop', text: 'For more powerful experience' },
	{ title: 'API and MCP server', text: 'Expand your superpowers' },
    ];

    const mapper = (item: any, idx: number) => (
	<SwiperSlide key={idx}>
	    <div className={[ 'item', `item${idx + 1}` ].join(' ')}>
		<div className="textWrapper">
		    <p>
			<span>{item.title}</span>
			{item.text}
		    </p>
		</div>
		<div className="imgWrapper">
		    <div className="img" />
		</div>
	    </div>
	</SwiperSlide>
    );

    return (
	<div className="section platforms">
	    <div className="swiperWrapper">
		<Swiper
		    slidesPerView="3"
		    spaceBetween={16}
		    slidesOffsetAfter={16}
		    slidesOffsetBefore={16}
		    breakpoints={{
			300: { slidesPerView: 1.5, spaceBetween: 16 },
			375: { slidesPerView: 1.7 },
			438: { slidesPerView: 2 },
			500: { slidesPerView: 2.25 },
			550: { slidesPerView: 2.5 },
			600: { slidesPerView: 2.8, slidesOffsetAfter: 16, slidesOffsetBefore: 16 },
			642: { slidesPerView: 3, slidesOffsetAfter: 0, slidesOffsetBefore: 0 },
			1000: { slidesPerView: 3, spaceBetween: 32, slidesOffsetAfter: 0, slidesOffsetBefore: 0 },
		    }}
		>
		    {slides.map(mapper)}
		</Swiper>
	    </div>
	</div>
    );
};

export default Platforms;